import React from "react";
import { Box, Chip, IconButton, Stack, Tooltip, Typography } from "@mui/material";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import MovieIcon from "@mui/icons-material/Movie";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { COLORS } from "./constants";
import { formatBytes } from "./utils";

export function VideoLibrary({ videos, selectedId, onSelect, onDelete }) {
  if (!videos.length) {
    return (
      <Stack alignItems="center" py={2} spacing={0.75}>
        <InsertDriveFileIcon sx={{ color: "rgba(255,255,255,0.08)", fontSize: 30 }} />
        <Typography sx={{ color: COLORS.muted, fontSize: 13 }}>No videos uploaded yet</Typography>
      </Stack>
    );
  }

  return (
    <Stack spacing={0.75}>
      {videos.map((v) => {
        const sel = selectedId === v.id;
        return (
          <Box
            key={v.id}
            onClick={() => onSelect(v.id)}
            sx={{
              p: 1.25, cursor: "pointer", borderRadius: "12px",
              border: `1px solid ${sel ? "rgba(43,189,175,0.5)" : COLORS.border}`,
              bgcolor: sel ? "rgba(43,189,175,0.08)" : COLORS.panelSoft,
              transition: "all 0.12s",
              "&:hover": { borderColor: sel ? "rgba(43,189,175,0.5)" : COLORS.borderStrong }
            }}
          >
            <Stack direction="row" spacing={1.25} alignItems="center">
              <MovieIcon sx={{ fontSize: 16, color: sel ? COLORS.cyan : COLORS.amber, flexShrink: 0 }} />
              <Box flex={1} minWidth={0}>
                <Typography noWrap sx={{ color: COLORS.text, fontSize: 13, fontWeight: 700 }}>
                  {v.originalName || v.fileName}
                </Typography>
                <Stack direction="row" spacing={1}>
                  <Typography sx={{ color: COLORS.muted, fontSize: 11 }}>{formatBytes(v.fileSize)}</Typography>
                  <Typography sx={{ color: COLORS.muted, fontSize: 11 }}>
                    {v.uploadedAt ? new Date(v.uploadedAt).toLocaleString() : ""}
                  </Typography>
                </Stack>
              </Box>
              {sel && (
                <Chip
                  label="Selected" size="small"
                  sx={{ height: 18, fontSize: 10, bgcolor: "rgba(43,189,175,0.15)", color: COLORS.cyan, borderRadius: "8px" }}
                />
              )}
              <Tooltip title="Delete this video from the server (permanent)">
                <IconButton
                  onClick={(e) => { e.stopPropagation(); onDelete(v); }}
                  sx={{ color: COLORS.red, border: `1px solid ${COLORS.border}`, borderRadius: "10px", p: 0.5 }}
                >
                  <DeleteOutlineIcon sx={{ fontSize: 15 }} />
                </IconButton>
              </Tooltip>
            </Stack>
          </Box>
        );
      })}
    </Stack>
  );
}
